var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1155.2762 1154.1854",
    id: "svg26",
    width: 1155.2762,
    height: 1154.1854,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1235"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.04384,
    y: 396.53267,
    width: 353.69396,
    height: 415.20596,
    id: "rect1655"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      vectorEffect: "non-scaling-stroke",
      fill: "#000000",
      InkscapeStroke: "none"
    },
    d: "M 583.49414,9.4121094 C 378.64856,6.8666523 176.92278,123.89588 80.316406,306.10742 -14.417654,474.03935 -12.496496,689.28323 85.078125,855.60156 196.15762,1055.3332 433.52083,1174.1874 660.10156,1138.5039 c 80.84908,-11.7418 156.91974,-43.8752 225.30078,-86.0039 70.14169,18.7647 139.92556,42.0643 210.84766,62.3438 l 25.957,7.4218 -7.4082,-25.959 c -19.7836,-69.3271 -42.7593,-139.36117 -63.5097,-208.55465 79.7892,-125.08125 114.0024,-280.61828 80.6367,-427.25 C 1086.9788,236.89266 896.70545,53.089565 670.9707,17.949219 641.9455,12.571736 612.68801,9.7748789 583.49414,9.4121094 Z m -0.37695,30.0722656 c 27.60844,0.300872 55.23974,2.915859 82.60156,7.998047 l 0.21875,0.04102 0.21875,0.0332 C 878.80306,80.568651 1060.3114,255.8714 1102.5684,466.6582 l 0.039,0.19336 0.043,0.19141 c 31.9092,140.06856 -1.8006,290.57537 -80.2539,410.37695 l -3.8145,5.82617 1.9883,6.67578 c 18.7603,62.94956 39.2317,126.07633 57.6094,188.28713 -63.2785,-18.7575 -126.612,-39.3861 -191.13673,-56.3945 l -6.29297,-1.6583 -5.50977,3.4629 c -67.16453,42.1963 -141.58194,73.9051 -219.54687,85.211 l -0.0918,0.014 -0.0918,0.014 c -213.26249,33.6208 -439.5952,-79.6276 -544.26368,-267.9199 l -0.0859,-0.15625 -0.0918,-0.15234 c -92.080115,-156.77919 -93.9004,-361.72905 -4.5,-520.00977 l 0.0996,-0.17578 0.0937,-0.17774 C 197.70609,148.63076 389.8581,37.378269 583.11719,39.484375 Z",
    id: "path4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m 788.43123,445.74501 c 28.14613,-2.65083 31.89667,30.28613 35.20567,50.65694 1.32831,28.91801 31.36566,35.87413 54.97038,30.99303 36.6777,-1.23378 73.46841,-3.9013 110.11997,-0.66241 20.68365,8.10868 18.46005,36.26088 -0.98,44.09968 -18.0878,15.19949 -45.44108,-5.06195 -55.70853,20.75588 -18.36892,28.66469 -22.8678,59.75308 -38.68992,93.05089 -13.24434,27.25536 -40.27724,44.98704 -46.22595,74.78414 1.44524,24.33412 32.22017,26.75132 48.44285,38.37209 27.16796,13.08709 55.54349,23.43199 84.03235,33.22475 15.4282,17.93935 4.3679,46.34478 -19.10385,49.322 -27.94802,10.06246 -49.65454,-11.60782 -73.14255,-20.5211 -30.86012,-14.19837 -53.18574,-48.71159 -89.65668,-48.61463 -23.26125,2.89679 -38.64996,23.03993 -58.91039,33.04895 -30.78602,18.51337 -64.40983,32.94964 -99.90404,39.29559 -23.68038,1.02099 -32.58808,-27.47649 -15.40018,-42.05846 14.0332,-21.44616 40.41776,-17.60285 60.12584,-27.88883 23.36908,-10.65996 53.68283,-18.21778 64.53122,-44.19593 8.12565,-23.6902 -17.55782,-39.36511 -29.0568,-56.72896 -12.76111,-16.79413 -31.52452,-37.76424 -26.58753,-59.62081 13.30297,-24.81787 40.08569,-1.96019 49.63707,13.81869 14.21245,16.97898 23.37964,38.13984 39.68046,53.19498 21.06684,13.51643 40.38855,-11.45262 50.91043,-27.10631 17.21683,-27.66823 33.34613,-56.70441 43.02139,-87.94803 6.752,-17.04437 -1.4686,-34.35375 -21.70212,-27.98382 -78.99656,-1.12146 -157.93928,5.54578 -236.93158,2.57298 -30.12553,-1.16413 -21.90543,-36.4312 2.15571,-40.37114 22.64464,-6.4577 45.57857,-0.12643 69.08564,-3.78465 28.83326,-1.18272 61.44283,5.89945 87.01947,-10.86738 5.60175,-16.56823 -9.13987,-35.86608 -8.86087,-53.95253 -2.24816,-13.82498 8.01647,-25.03318 21.92254,-24.8856 z",
    id: "path20",
    style: {
      strokeWidth: 1.14337
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text1653",
    style: {
      whiteSpace: "pre",
      shapeInside: "url(#rect1655)",
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinejoin: "round",
      strokeMiterlimit: 120.1,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "A",
    id: "text1723",
    style: {
      fontSize: "627.495px",
      stroke: "#000000",
      strokeWidth: 12,
      strokeLinejoin: "round",
      strokeMiterlimit: 120.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 522.40311,761.08142 468.43854,622.40503 H 290.85745 L 237.52038,761.08142 H 180.41833 L 355.48944,311.16751 h 50.82709 L 580.76014,761.08142 Z M 401.29657,436.66651 q -1.88248,-5.01996 -6.27495,-18.19736 -4.39246,-13.17739 -8.78493,-26.98228 -3.76497,-14.43239 -6.27495,-21.96233 -4.39246,19.45235 -10.03992,38.2772 -5.64745,18.19735 -9.41242,28.86477 l -50.8271,135.53892 h 141.81387 z",
    id: "path1813"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.9380ac34172485d247f2c01060180f45.svg";
export { ForwardRef as ReactComponent };